import React from 'react';

interface UnApplyPrepaymentsModalProps {
  data: Array<any>;
  onSelectPrepayment: (selectedPayment: any) => void; // Add this prop
}

// const UnApplyPrepayments: React.FC<UnApplyPrepaymentsModalProps> = ({
//   data,
//   onSelectPrepayment,
// }) => {
//   return (
//     <>
//       <div className="table-responsive rounded-2">
//         <table className="table table-borderless table-hover text-nowrap ">
//           <thead className="bg-theme bg-opacity-30">
//             <tr>
//               <th>رقم الدفعة</th>
//               <th>تاريخ الدفعة</th>
//               <th>المبلع</th>
//               <th>amountUnApply</th>
//               <th></th>
//             </tr>
//           </thead>
//           <tbody>
//             {data.map((payment, index) => {
//               return (
//                 <tr key={index}>
//                   <td className="align-middle">{payment.code}</td>
//                   <td className="align-middle">
//                     {new Date(payment.paymentDate).toLocaleDateString()}
//                   </td>
//                   <td className="align-middle"> {payment.amount}</td>
//                   <td className="align-middle">{payment.amountUnApply}</td>
//                   <td className="align-middle ">
//                     <button
//                       // disabled={isAlreadySelected}
//                       className="btn btn-outline-theme w-100"
//                       onClick={() => onSelectPrepayment(payment)} // استدعاء دالة الاختيار
//                     >
//                       إختيــــار
//                     </button>
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>
//     </>
//   );
// };

const UnApplyPrepayments: React.FC<UnApplyPrepaymentsModalProps> = ({ data, onSelectPrepayment }) => {
  // إذا لم توجد بيانات، نعرض رسالة بدلاً من جدول فارغ
  if (data.length === 0) {
    return (
      <div className='text-center py-5'>
        <i className='fas fa-money-bill-wave fa-3x text-theme mb-3'></i>
        <h5 className='text-muted'>لا توجد دفعات مقدمة متاحة</h5>
        <p className='text-muted'>جميع الدفعات المقدمة قد تم استخدامها أو لا توجد دفعات مطابقة</p>
      </div>
    );
  }

  return (
    <div className='  shadow rounded-2 p-3'>
      <div className='alert alert-info d-flex align-items-center mb-3'>
        <i className='fas fa-info-circle me-2'></i>
        <small>يمكنك اختيار دفعة مقدمة من القائمة أدناه لتطبيقها على الفاتورة الحالية</small>
      </div>

      <div className='table-responsive rounded-2 border'>
        <table className='table table-hover mb-0'>
          <thead className='bg-theme text-white'>
            <tr>
              <th className='ps-3'>رقم الدفعة</th>
              <th>تاريخ الدفعة</th>
              <th>المبلغ الكلي</th>
              <th>المبلغ المتاح</th>
              <th className='text-center pe-3'>الإجراء</th>
            </tr>
          </thead>
          <tbody>
            {data.map((payment, index) => {
              const isAmountZero = payment.amountUnApply <= 0;

              return (
                <tr key={index} className={isAmountZero ? 'opacity-50' : ''}>
                  <td className='align-middle ps-3'>
                    <div className='d-flex align-items-center'>
                      <i className='fas fa-money-check-alt   me-2 text-theme'></i>
                      <span className='fw-bold'>{payment.code}</span>
                    </div>
                  </td>
                  <td className='align-middle'>
                    <span className='badge bg-light text-dark'>
                      {/* {new Date(payment.paymentDate).toLocaleDateString('ar-SA')} */}
                      {payment.paymentDate?.split('T')[0] }
                    </span>
                  </td>
                  <td className='align-middle'>
                    <span className='text-success fw-bold'>
                      {typeof payment.amount === 'number' ? payment.amount.toFixed(2) : payment.amount}
                    </span>
                  </td>
                  <td className='align-middle'>
                    <span className={`fw-bold ${isAmountZero ? 'text-danger' : 'text-primary'}`}>
                      {typeof payment.amountUnApply === 'number'
                        ? payment.amountUnApply.toFixed(2)
                        : payment.amountUnApply}
                    </span>
                    {isAmountZero && <span className='badge bg-warning text-dark ms-2'>مستنفذ</span>}
                  </td>
                  <td className='align-middle text-center pe-3'>
                    <button
                      disabled={isAmountZero}
                      className='btn btn-sm btn-outline-theme'
                      onClick={() => onSelectPrepayment(payment)}
                      title={isAmountZero ? 'لا يوجد رصيد متاح في هذه الدفعة' : 'اختيار هذه الدفعة'}
                    >
                      {isAmountZero ? (
                        <>
                          <i className='fas fa-ban me-1'></i>
                          غير متاح
                        </>
                      ) : (
                        <>
                          <i className='fas fa-check-circle me-1'></i>
                          اختيار
                        </>
                      )}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className='mt-3 p-2 border border-1 border-theme rounded'>
        <div className='row'>
          <div className='col-md-6'>
            <small className='text-muted'>
              <i className='fas fa-circle text-success me-1'></i>
              إجمالي الدفعات المتاحة: <strong>{data.length}</strong>
            </small>
          </div>
          <div className='col-md-6 text-end'>
            <small className='text-muted'>
              المبلغ الإجمالي المتاح:
              <strong className='text-primary ms-1'>
                {data.reduce((sum, item) => sum + (item.amountUnApply || 0), 0).toFixed(2)}
              </strong>
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnApplyPrepayments;
